import { setCookie } from "cookies-next";

export function cleanWhitespace(source: string): string {
  try {
    const _cleaned = source.replace(/\r?\n|\r/g, " ").replace(/^\s+|\s+$/g, "");

    return _cleaned;
  } catch (error) {
    return source;
  }
}

/**
 * calculates url from parts
 * @param course
 * @param subject
 * @param questionSlug
 * @param questionId
 */
export function calculateSlugForQuestion(
  course: string,
  subject: string,
  questionSlug: string,
  questionId: string | number,
) {
  let slug = "/";
  if (course) {
    slug += course;
  }
  if (subject) {
    slug += `/${subject}`;
  }
  if (questionId && questionSlug) {
    slug += `/${questionSlug}-${questionId}`;
  }

  return slug;
}

/**
 * copies text into clipboard
 * @param text
 */
export function copyToClipboard(text: string): boolean {
  try {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * girilen ismi, isim soyisim olarak ayirir
 * @param {*} value
 */
export function splitName(value: string): {
  first_name: string;
  last_name: string;
} {
  const response = {
    first_name: "",
    last_name: "",
  };
  if (!value) {
    return response;
  } else if (value.trim().split(" ").length == 1) {
    response.first_name = value.trim().split(" ").slice(-1).join(" ");
    response.last_name = "";
  } else {
    response.first_name = value.trim().split(" ").slice(0, -1).join(" ");
    response.last_name = value.trim().split(" ").slice(-1).join(" ");
  }
  return response;
}

export function saveContentLangToCookie(lang: string, ctx: any) {
  try {
    setCookie("kz_content_lang", lang, {
      path: "/",
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
      sameSite: "lax",
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
      req: ctx.req,
      res: ctx.res,
    });
  } catch (error) {
    console.error(error);
  }
}

export function normalizeTimeUnitForDisplay(amount: number) {
  return amount.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
}
